<template>
  <div class="page-wrapper">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>
